import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import nl2br from 'react-nl2br';
import { formatMoney } from '../utils';
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
  }
}));

const raw = (html) => {
  return <div dangerouslySetInnerHTML={{__html: html}}></div>;
}

const renderBenefits = (job) => {
  if( job.benefits.length == 0 ) return <></>;
  return <>
    <Typography color='primary' gutterBottom variant='subtitle1'>Benefits</Typography>
    <Typography gutterBottom variant='subtitle1'>{job.benefits.join(', ')}</Typography>

</>;
}

const renderIfPresent = (job, attr, label, rawOutput = false) => {
  if( (job[attr] == null) || (job[attr] == "") ) return <></>;
  return <>
    <Typography color='primary' gutterBottom variant='subtitle1'>{label}</Typography>
    <Typography gutterBottom variant='subtitle1' component='div'>{rawOutput ? nl2br(job[attr]) : job[attr]}</Typography>

</>;
}

const renderSalary = (job) => {
  if( (job.max_salary === null)&&(job.min_salary === null) ) return <></>;
  let parts = [job.min_salary, job.max_salary].filter( (el) => ((el != "")&&( el != null)) ).map( (p) => "$" + formatMoney(p, (job.salary_units == 'hour') ? 2 : 0) );
  return <>
    <Typography color='primary' gutterBottom variant='subtitle1'>Salary</Typography>
    <Typography gutterBottom variant='subtitle1'>{parts.join(' - ')} per {job.salary_units}</Typography>

</>;
}

export default function JobDetails(props) {
  let job = props.job;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div>
    <Typography gutterBottom variant='h5'>{job.title}</Typography>
    <Typography color='primary' variant='subtitle1'>{job.location}</Typography>

    <Typography gutterBottom variant='subtitle2'>{job.job_statuses_i18n.join(', ')}</Typography>
    {renderBenefits(job)}
    {renderSalary(job)}
    <Typography color='primary' gutterBottom variant='subtitle1'>Job description</Typography>
    <Typography gutterBottom variant='body1' component='div'>{nl2br(job.description)}</Typography>
    {renderIfPresent(job, 'work_hours', 'Work hours')}
    {renderIfPresent(job, 'skills', 'Skills')}
    {renderIfPresent(job, 'education_requirements', 'Education requirements', true)}
    {renderIfPresent(job, 'experience_requirements', 'Experience requirements', true)}
    {renderIfPresent(job, 'qualifications', 'Qualifications')}
    {renderIfPresent(job, 'responsibilities', 'Responsibilities')}
  </div>);
}
